import ReactDOM from "react-dom";

const HeaderRightPortal = ({ children }) => {
  const el = document.getElementById("hd_right_container");
  if (el) {
    return ReactDOM.createPortal(children, el);
  } else {
    return null;
  }
  return ReactDOM.createPortal(children, el);
};

export default HeaderRightPortal;
